import React from 'react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { AlertTriangle } from 'lucide-react';
import { MemberPenalty, isPenaltyActive, getPenaltyDisplayText } from '@/types/penalty';
import { useLanguage } from '@/hooks/use-language';

interface PenaltyNoticeProps {
  penalty: MemberPenalty | null;
  className?: string;
}

export function PenaltyNotice({ penalty, className = "" }: PenaltyNoticeProps) {
  const { language } = useLanguage();

  if (!penalty || penalty.totalDots === 0 || !isPenaltyActive(penalty)) {
    return null;
  }

  const penaltyText = getPenaltyDisplayText(penalty, language);
  const endDate = penalty.penaltyEndDate ? new Date(penalty.penaltyEndDate).toLocaleDateString() : '';

  return (
    <Alert className={`border-orange-200 bg-orange-50 ${className}`} variant="destructive">
      <AlertTriangle className="h-4 w-4 text-orange-600" />
      <AlertDescription className="text-orange-800">
        <strong>{language === 'no' ? 'Straff aktiv' : 'Penalty Active'}:</strong> {penaltyText}
        {endDate && (
          <div className="text-sm mt-1">
            {language === 'no' ? `Utløper: ${endDate}` : `Expires: ${endDate}`}
          </div>
        )}
      </AlertDescription>
    </Alert>
  );
}
